<template>
  <div>
    <div id="calendar-filter-wrapper">
      <v-container grid-list-md class="pa-0" fluid>
        <v-layout row wrap>
          <v-flex md3 xs12>
            <v-select
              v-if="!loading && companies.length > 1"
              :items="filteredCompanies"
              :item-color="companyPrimaryColor"
              backgroundColor="menu"
              item-text="name"
              item-value="id"
              hide-details
              v-on:input="loadActiveCompData()"
              v-model="activeComp"
              no-data-text="Geen bedrijven gevonden."
              label="Selecteer bedrijf"
              outlined
              dense
              >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content  class="pt-0" >
                    <v-text-field
                      :color="companyPrimaryColor"
                      placeholder="Zoeken"
                      append-icon="search"
                      v-model="searchCompanies"
                      hide-details
                      dense
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
                <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
              </template>
            </v-select>
          </v-flex>
          <v-flex md3 xs12 >
            <v-select
              v-if="!loading"
              outlined
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              backgroundColor="menu"
              :items="branches"
              item-text="branchName"
              item-value="id"
              v-model="selectedBranch"
              label="Vestiging"
              attach
              v-on:input="getEmployees()"
              hide-details
              dense
              >
            </v-select>
          </v-flex>
        </v-layout>
      </v-container>

      <div style="z-index: 100;" v-if="loading || calanderChecking" class="blackbox-loader"></div>

      <v-container v-show="!loading && resources.length > 0" grid-list-md class="pa-0 ma-0 mt-2" fluid>
        <v-layout row wrap>
          <v-flex md4 xs6>
            <v-card class="usertype-total" outlined>
              <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">{{ activeResources }}</div>
              <div class="usertype-total-desc">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span :style="{color: $vuetify.theme.themes[theme].text}">Actieve medewerkers <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                  </template>
                  <span class="white--text">Aantal actieve medewerkers <span class="white--text" v-if="calendarView == 'day'">vandaag</span><span class="white--text" v-if="calendarView == 'week'">deze week</span></span>
                </v-tooltip>           
              </div>
            </v-card>
          </v-flex>
          <v-flex md4 xs6>
            <v-card class="usertype-total" outlined>
              <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">{{ totalHours }}</div>
              <div class="usertype-total-desc">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span :style="{color: $vuetify.theme.themes[theme].text}">Uren <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                  </template>
                  <span class="white--text">Totaal antal werkuren <span class="white--text" v-if="calendarView == 'day'">vandaag</span><span class="white--text" v-if="calendarView == 'week'">deze week</span></span>
                </v-tooltip>           
              </div>
            </v-card>
          </v-flex>
          <v-flex md4 xs12>
            <v-card class="usertype-total" outlined>
              <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">€{{ goalRevenue.toFixed(0) }}</div>
              <div class="usertype-total-desc">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span :style="{color: $vuetify.theme.themes[theme].text}">Doel omzet <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                  </template>
                  <span class="white--text">Doel omzet <span class="white--text" v-if="calendarView == 'day'">vandaag</span><span class="white--text" v-if="calendarView == 'week'">deze week</span></span>
                </v-tooltip>           
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      

      <v-card v-show="!loading && resources.length > 0" outlined style="margin: 10px 0">
        <v-container grid-list-md class="pa-2" fluid>
          <v-layout row wrap>
            <v-flex md4>
              <v-btn v-if="!calendarDayView" class="mx-1" dark outlined depressed :color="companyPrimaryColor" @click="openDuplicatingScheduleModal()">planning dupliceren</v-btn>
            </v-flex>
            <v-flex md4 class="pb-0">
              <div class="text-center">
                <h3><strong>Week {{ selectedWeeknumber }}</strong></h3>
                <p class="ma-0" style="font-size: 14px;" v-if="calendarView == 'day'">{{ selectedDate | moment("dddd D MMMM YYYY")}}</p>
                <p class="ma-0" style="font-size: 14px;" v-if="calendarView == 'week'">{{ selectedWeekFirstDay }} - {{ selectedWeekLastDay }}</p>
              </div>
            </v-flex>
            <v-flex md4>
              <div class="text-right">
                <v-btn class="mx-1" dark :outlined="!calendarDayView" depressed :color="companyPrimaryColor" @click="dayView()">Dag</v-btn>
                <v-btn class="ml-1 mr-4" dark :outlined="calendarDayView" depressed :color="companyPrimaryColor" @click="weekView()">Week</v-btn>
                <v-btn class="mx-1" fab dark outlined small  :color="companyPrimaryColor" @click="previous()">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
                <v-btn class="mx-1" fab dark outlined small :color="companyPrimaryColor" @click="next()">
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </div>

    <div v-show="!loading && resources.length > 0" class="calendar-wrapper">
      <div :style="{maxHeight: calendarHeight}">
        <FullCalendar
          ref="branchCalendar"
          :options="calendarOptions"
          selectConstraint="businessHours"
          eventConstraint="businessHours"
          :columnHeaderFormat="columnHeaderFormat"
          @eventDrop="eventResize"
          @eventClick="eventClick"
          @eventResize="eventResize"
          @select="select"
          :loading="calendarLoading"
          :resourceRender="resourceRender"
        />

        <!-- <FullCalendar
          schedulerLicenseKey='GPL-My-Project-Is-Open-Source'
          ref="fullCalendar"
          timeZone="local"
          :disableResizing="false"
          :firstDay="0"
          defaultView="resourceTimeGridDay"
          :slotLabelFormat="slotLabelFormat"
          scrollTime="00:60:00"
          :header="false"
          selectConstraint="businessHours"
          eventConstraint="businessHours"
          :eventStartEditable="true"
          :eventResourceEditable="false"
          :droppable="false"
          :editable="true"
          :selectOverlap="false"
          :allDaySlot="false"
          :slotEventOverlap="false"
          :eventOverlap="false"
          :selectable="true"
          :selectMirror="true"
          :businessHours="businessHours"
          :minTime="minTime"
          :maxTime="maxTime"
          :eventBackgroundColor="companyPrimaryColor"
          :slotDuration="slotDuration"
          :plugins="calendarPlugins"
          :resources="resources"
          :events="events"
          :eventResizableFromStart="eventResizableFromStart"
          contentHeight="auto"
          @eventDrop="eventResize"
          @eventClick="eventClick"
          @eventResize="eventResize"
          @select="select"
          @resourceRender="resourceRender"
        />  -->
      </div>
    </div>

    <div v-show="!loading && !calanderChecking && resources.length == 0">
      <p style="text-align: center; padding: 50px;">Er zijn geen medewerkers actief voor de geselecteerde vestiging.</p>
    </div>

    <v-dialog hide-overlay v-model="removeDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Periode verwijderen</v-card-title>
        <v-card-text>Verwijder de geselecteerde periode.</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn :color="companySecondaryColor" text @click="removeDialog = false, refreshCalendar()">Annuleren</v-btn>
          <v-spacer></v-spacer>
          <v-btn :color="companyPrimaryColor" dark @click="removeEvent()">Verwijderen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="duplicateScheduleModal" persistent max-width="600">
      <v-card>
         <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 style="color:white">Weekplanning dupliceren</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="duplicateScheduleModal = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert
          class="ma-0 pa-2"
          v-if="duplicateFeedback"
          :value="true"
          type="warning"
          >
          {{ duplicateFeedback }} 
        </v-alert>

        <v-divider></v-divider>

        <v-card-text>
          <p class="my-4">Gebruik de exacte planning van deze week vaker door deze te dupliceren en toe te passen op een andere week.</p>
          <v-select
            class="mt-4"
            :items="resources"
            :item-color="companyPrimaryColor"
            background-color="white"
            backgroundColor="menu"
            item-value="id"
            item-text="title"
            hide-details
            multiple
            v-on:input="checkingDuplicatingSchedule()"
            v-model="selectedResourcesForCopy"
            label="Weekplanning dupliceren van:"
            outlined
            return-object
            >
          </v-select>
          <v-select
            class="mt-4"
            v-if="weeksInTheFuture.length > 0"
            :items="weeksInTheFuture"
            :item-color="companyPrimaryColor"
            background-color="white"
            backgroundColor="menu"
            item-value="weeknumber"
            item-text="name"
            hide-details
            v-on:input="checkingDuplicatingSchedule()"
            v-model="selectedWeekForCopy"
            label="Weekplanning dupliceren naar:"
            outlined       
            >
          </v-select> 

          <div class="pa-3 mt-4" v-if="adjustedScheduleEmployees.length > 0" :style="{backgroundColor: $vuetify.theme.themes[theme].background}">
            <p class="mb-1">Er is al een aangepaste planning gevonden voor:</p>
            <div v-for="(employee, index) in adjustedScheduleEmployees" :key="index">
              <strong>&#x2022; {{ employee.name }}</strong>
            </div>
          </div>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0" >
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="duplicateScheduleModal = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="duplicatePlanning()"
                  >
                  Planning dupliceren
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      top
      :timeout="snackbar.timeout"
      >
      <v-row>
        <v-icon color="white" class="mx-3">{{ snackbar.icon}}</v-icon>
        <span class="py-2 white--text">{{ snackbar.text}}</span>
      </v-row>
    </v-snackbar>

  </div>
</template>

<script>
import { bus } from "../main";
import db from "../firebase/init";
import platform from 'platform'; 
import moment from 'moment';

//Full Calendar 
  import FullCalendar from "@fullcalendar/vue";
  import interactionPlugin from "@fullcalendar/interaction";
  import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import scrollgrid from "@fullcalendar/scrollgrid";

// import FullCalendar from '@fullcalendar/vue'
// import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
// import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
// import dayGridPlugin from '@fullcalendar/daygrid'
// import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
// import NL from '@fullcalendar/core/locales/nl';

// import "@fullcalendar/core/main.css";
// import "@fullcalendar/daygrid/main.css";
// import "@fullcalendar/timegrid/main.css";

export default {
  name: "Schedule",
  components: {
    FullCalendar
  },
  props: ["urlStart", "urlEnd"],

  data() {
    return {
    // Full Calendar
    calendarOptions: {
      plugins: [dayGridPlugin, interactionPlugin, resourceTimeGridPlugin, scrollgrid],
      longPressDelay: 200, // Touch delay for select
      eventLongPressDelay: 500, // Touch delay for select
      selectLongPressDelay: 500, // Touch delay for select
      initialView: "resourceTimeGridDay",
        dayMinWidth: 135,
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "resourceTimeGridWeek",
        },
        businessHours: {
          daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
          startTime: "05:00",
          endTime: "23:59",
        },
        slotLabelFormat: {
          hour: "numeric",
          minute: "2-digit",
          omitZeroMinute: false,
          meridiem: false,
          hour12: false,
        },
        calendarView: 'day',
        firstDay: 1,
        titleFormat: { year: "numeric", month: "2-digit", day: "2-digit" },
        schedulerLicenseKey: "GPL-My-Project-Is-Open-Source",
        slotMinTime: "07:00:00",
        slotMaxTime: "23:59:00",
        slotDuration: "00:30:00",
        contentHeight: "auto",
        slotEventOverlap: false,
        eventTextColor: "#000000",
        eventBorderColor: "#1f89e5",
        eventOverlap: false,
        selectOverlap: false,
        dayMaxEvents: true,
        weekends: true,
        selectable: true,
        selectMirror: true,
        eventStartEditable: true,
        eventDurationEditable: true,
        eventResizableFromStart: true,
        eventResourceEditable: false,
        refetchResourcesOnNavigate: true,
        droppable: false,

        dayHeaderFormat: { weekday: "long" },
        displayEventTime: true,
        resourceOrder: 'order',
        eventResizableFromStart: false,
        timeZone: "local",
        locale: "NL",
        allDaySlot: false,
        resources: new Array(),
        initialEvents: this.fetchEvents,
        loading: this.isLoading,
        resourceLabelContent: (arg) => {
          return this.resourceRender(arg);
        },
        eventResize: (eventData) => {
          return this.eventResize(eventData);
        },
        eventDrop: (eventData) => {
          return this.eventResize(eventData);
        },
        eventClick: (eventData) => {
          return this.eventClick(eventData);
        },
        select: (eventData) => {
          return this.select(eventData);
        },
    },
    columnHeaderFormat: { weekday: "short" },
    
    //calendarPlugins: [resourceTimeGridPlugin],
    minTime: "07:00",
    maxTime: "23:00",
    dayformat: "dddd",
    slotDuration: '00:30:00',
    allDaySlot: false,
    defaultDate: new Date(),
    duplicateScheduleModal: false,
    slotLabelFormat:{
      hour: 'numeric',
      minute: '2-digit',
      omitZeroMinute: false,
      meridiem: false,
      hour12:false
    },
    eventResizableFromStart: true,

    selectedBranch: null,
    branches: [],
    events: [],

    businessHours: {
      // days of week. an array of zero-based day of week integers (0=Sunday)
      daysOfWeek: [ 0, 1, 2, 3, 4, 5 ,6 ], // Monday - Thursday

      startTime: '7:00', // a start time (10am in this example)
      endTime: '22:00', // an end time (6pm in this example)
    },
    calanderChecking: true,
    removeDialog: false,
    selectedEvent: null,
    calendarChecking: true,
    loading: true,
    // calendarLoading: true,
    feedback: null,
    filterToday: true,
    filterWeek: false,
    filterMonth: false,
    filterPeriod: false,
    searchCompanies: "",
    selectedPeriodDay: "01",
    
    selectedPeriodYear: moment().year(),
    selectedPeriodMonth: Number(moment().format("M")),
    activeCompData: {},
    conversions: [],
    activeCompDataOriginal: {},
    companies: [],
    branches: [],
    resources: [],
    activeComp: "", 
    compStartYear: null,
    compStartMonth: null, 
    dataLoading: false,
    toggle_exclusive: 1,
    today: null,
    calendarView: 'day',
    calendarHeight: "1000px",
    selectedWeekFirstDay: null,
    selectedWeekLastDay: null,
    selectedDate: null,
    selectedYear: null,
    selectedWeeknumber: null,
    conversionPeriodType: 'day',
    conversionPeriodStart: null,
    conversionPeriodEnd: null,
    currentMonth: Number(moment().format("M")),
    selectedSources: [],
    calendar: null,
    activeResources: 0,
    totalHours: 0,
    weeksInTheFuture: [],
    duplicateFeedback: null,
    selectedResourcesForCopy: null,
    selectedWeekForCopy: null,
    adjustedScheduleEmployees: [],
    goalRevenue: 0,
    snackbar: {
      active: false,
      text: "",
      icon: "",
      timeout: -1,
      color: "",
    },
    conversionTableLabels: [],
    positions: [],
    types: [
      {
        id: 'salonhub',
        name: 'Salonhub'
      },
      {
        id: 'wordpressForm',
        name: 'Wordpress Formulier'
      }
    ],
    employees: [],
  }
  },

  created() {
    this.loadUserComp();
    this.calculcateWeeksInTheFuture();
    this.today = moment().unix();
    this.selectedDate = moment().format("YYYY-MM-DD");
    this.selectedYear = moment().year();
    this.selectedWeeknumber = moment(moment(this.selectedDate ).add(1, 'days')).isoWeek();
    this.selectedWeekFirstDay = moment(moment(this.selectedDate ).add(1, 'days')).startOf('week').format("DD MMMM YYYY");
    this.selectedWeekLastDay = moment(moment(this.selectedDate ).add(1, 'days')).endOf('week').format("DD MMMM YYYY");
    window.addEventListener('resize', this.calculateCalendarHeight);
  },

  methods: {
    // SELECT EVENT
    eventClick(info) {
      this.removeDialog = true
      this.selectedEvent = info.event
      info.el.style.backgroundColor = this.companyPrimaryColor;
    },

    dayView(){
      this.calendar.changeView('resourceTimeGridDay');
      this.calendarView = 'day';
      this.calculateSummary();
      this.calendar.gotoDate(this.selectedDate);
      this.$refs.branchCalendar.getApi().refetchEvents();
    },

    weekView(){
      this.calendar.changeView('resourceTimeGridWeek');
      this.calendarView = 'week';
      this.calculateSummary();
      this.calendar.gotoDate(this.selectedDate);
      this.$refs.branchCalendar.getApi().refetchEvents();
    },

    async fetchEvents() {
      return this.events;
    },

    calculcateWeeksInTheFuture(){
      let weeks = [];
      let currentWeek = moment().isoWeek();
      let currentYear = moment().format("YYYY")
      let weeksleft = 53 - (currentWeek);
      weeks = Array.apply(null, Array(weeksleft))
      let filledWeeks = []

      let weekArrayNumber = 0;
      let counter = 0;

      if(weeks.length > 0){
        new Promise(resolve =>{
          console.log("Promose week started")
          weeks.forEach(week =>{
            let start = moment(currentYear).add(currentWeek + weekArrayNumber, 'weeks').startOf("isoweek").format("D-MM-YYYY");
            let end = moment(currentYear).add(currentWeek + weekArrayNumber, 'weeks').endOf("isoweek").format("D-MM-YYYY");
            let weeknumber =  currentWeek + weekArrayNumber + 1
            let weekData = {
              start: start,
              end: end,
              weeknumber: weeknumber,              
              name: "Week  (" + weeknumber + ": " + start + " t/m " + end + ")"
            }
            filledWeeks.push(weekData)
            weekArrayNumber++
            counter++
          })
          if(counter == weeks.length){
            resolve();
          }
        })
        .then(()=>{
          console.log("Promose week resolbed")
          this.weeksInTheFuture = filledWeeks;
        })
      }
      else{
        this.weeksInTheFuture = filledWeeks;
      }
    },

    calculateCalendarHeight() {
      let height = null;
      let filterHeight = document.getElementById("calendar-filter-wrapper").clientHeight;
      let windowHeight = window.innerHeight;
      let availableHeight = windowHeight - (filterHeight + 90);
      height = availableHeight + "px";
      // this.$refs.branchCalendar.getApi().setOption("contentHeight");
      this.calendarHeight = availableHeight;
      this.calendarOptions.contentHeight = availableHeight;
    },

    removeEvent(){
      let counter = 0;
      let removeIndex;
      let resourceId;
      new Promise(resolve=>{
         this.events.forEach((event, index)=>{
           if(event.id == this.selectedEvent.id){
             removeIndex = index  
           }
           counter++
           if(counter == this.events.length){
             resolve()
           }
         })
      })
      .then(()=>{
        resourceId = this.events[removeIndex].resourceId;
        this.events.splice(removeIndex,1)
        this.removeDialog = false
        this.refreshCalendar();
        this.updatedResourceSchedulde(resourceId);
      })
    },

    openDuplicatingScheduleModal(){
      this.adjustedScheduleEmployees = [];
      this.selectedWeekForCopy = null;
      this.selectedResourcesForCopy = _.cloneDeep(this.resources);
      this.duplicateScheduleModal = true;
    },

    // Pre-check before duplicating
    checkingDuplicatingSchedule(){
      this.adjustedScheduleEmployees = [];
      this.selectedResourcesForCopy.forEach(resource =>{
        resource.databaseDocId = null;

        db.collection("schedules")
          .where("compId", "==", this.activeCompData.id)
          .where("branchId", "==", this.selectedBranch)
          .where("year", "==", this.selectedYear)
          .where("week", "==", this.selectedWeekForCopy)
          .where("employeeId", "==", resource.id)
          .get()
          .then(snap => {
            if(snap.size > 0){
              snap.forEach(doc => {
                let adjustedScheduleEmployee = {
                  id: resource.id,
                  name: resource.title
                };
                resource.databaseDocId = doc.id;
                this.adjustedScheduleEmployees.push(adjustedScheduleEmployee);
              })
            } 
          })
      });
    },

    duplicatePlanning(){
      let resourceCounter = 0;
      new Promise(resolve=>{
        this.selectedResourcesForCopy.forEach(resource =>{
          let counter = 0;
          let databaseDocId;
          let schedule = {
            sun: [],
            mon: [],
            tue: [],
            wed: [],
            thu: [],
            fri: [],
            sat: []
          }

          new Promise(resolve=>{
            this.events.forEach(event=>{
              let dayOfWeek = 'sun'
              if(event.resourceId == resource.id){
                if(event.day == '1'){ dayOfWeek = 'mon'};
                if(event.day == '2'){ dayOfWeek = 'tue'};
                if(event.day == '3'){ dayOfWeek = 'wed'};
                if(event.day == '4'){ dayOfWeek = 'thu'};
                if(event.day == '5'){ dayOfWeek = 'fri'};
                if(event.day == '6'){ dayOfWeek = 'sat'};
                schedule[dayOfWeek].push({
                  start: moment(event.start).format("HH:mm"),
                  end: moment(event.end).format("HH:mm"),
                })
                counter++
                if(counter == this.events.length){
                  resolve()
                }
              }
              else{
                counter++
                if(counter == this.events.length){
                  resolve()
                }
              }
            })
          })
          .then(()=>{
            if(resource.databaseDocId){
              db.collection("schedules")
              .doc(resource.databaseDocId)
              .set({
                schedule: schedule,
              }, { merge: true })
              .then(()=>{
                //console.log("Database document updated")
                resourceCounter++
                if(resourceCounter == this.selectedResourcesForCopy.length){
                  resolve()
                }
              })
              .catch(error => {
                this.duplicateFeedback("Planning dupliceren niet gelukt.")
                //console.error("Error updated schedule for duplication: ", error);
              });
            } 
            else{
              
              db.collection("schedules")
              .doc()
              .set({
                compId: this.activeCompData.id,
                branchId: this.selectedBranch,
                employeeId: resource.id,
                week: this.selectedWeekForCopy,
                year: this.selectedYear,
                schedule: schedule,
              }, { merge: true })
              .then(()=>{
                //console.log("Nieuw database document aangemaakt")
                resourceCounter++
                if(resourceCounter == this.selectedResourcesForCopy.length){
                  resolve()
                }
              })
              .catch(error => {
                this.duplicateFeedback("Planning dupliceren niet gelukt.")
                console.error("Error adding schedule for duplication: ", error);
              });
            }
          })

        })
      })
      .then(()=>{
        this.snackbar.active = true;
        this.snackbar.timeout = 3000;
        this.snackbar.color = "rgba(1, 230, 110, 0.7)";
        this.snackbar.icon = "thumb_up";
        this.snackbar.text = "Weekplanning succesvol gedupliceerd.";
        this.duplicateScheduleModal = false;
      })
    },

    // NIEUWE EVENT op basis van slepen in de calendar
    select(info){
      console.log("Selectinfo: ",info.start)
      let resourceId = info.resource.id;
      let mergeAvailable = false;
      let mergeEventIndexBefore
      let mergeEventIndexAfter
      let mergeTypeBefore = false;
      let mergeTypeAfter = false;
      let selectedDate = moment(info.start).format("YYYY-MM-DD");
      let start = moment(info.start).format("YYYY-MM-DD"+"T"+"HH:mm");
      let end = moment(info.end).format("YYYY-MM-DD"+"T"+"HH:mm");
      let counter = 0
      new Promise((resolve)=>{
        this.events.forEach((event, index)=>{
          if(event.resourceId == resourceId){
            this.events[index].color = "#cccccc";
          }
          if(event.resourceId == resourceId && event.start == end){
            mergeAvailable = true;
            mergeTypeBefore = true;
            mergeEventIndexBefore = index
          }
          if(event.resourceId == resourceId && event.end == start){
            mergeAvailable = true;
            mergeTypeAfter = true;
            mergeEventIndexAfter = index;
          }
          counter++
          if(counter == this.events.length){
            resolve()
          }
        })
      })
      .then(()=>{
        if(mergeAvailable){
          if(mergeTypeBefore && mergeTypeAfter){
            this.events[mergeEventIndexAfter].end = this.events[mergeEventIndexBefore].end;
            this.events[mergeEventIndexAfter].color = "#cccccc";
            this.events.splice(mergeEventIndexBefore,1)
          }
          else if(mergeTypeBefore && !mergeTypeAfter){
            this.events[mergeEventIndexBefore].start = start;
            this.events[mergeEventIndexBefore].color = "#cccccc";
          }
          else if(!mergeTypeBefore && mergeTypeAfter) {
            this.events[mergeEventIndexAfter].end = end;
            this.events[mergeEventIndexAfter].color = "#cccccc";
          }
        }
        else{
          let event = {
            id: this.events.length + "new",
            day: String(moment(selectedDate).day()).toLowerCase(),
            resourceId: info.resource.id,
            start: start,
            end: end,
            color: "#cccccc"
        
          }
          console.log("Event: ", event)
          this.events.push(event);
        }
      })
      .then(()=>{
        this.calendar.unselect();
        this.refreshCalendar();
        this.updatedResourceSchedulde(resourceId);
      })
    },

    // RESIZE OF VERPLAATSEN EVENT 
    eventResize(info) { 
      let resources = info.event.getResources();
      let resourceId = resources[0].id;
      let mergeAvailable = false;
      let mergeTypeAfter = false;
      let mergeTypeBefore = false;
      let selectedEventIndex
      let mergeEventIndexBefore
      let mergeEventIndexAfter
      let mergeType
      let start = moment(info.event.start).format("YYYY-MM-DD"+"T"+"HH:mm");
      let end = moment(info.event.end).format("YYYY-MM-DD"+"T"+"HH:mm");
      let counter = 0
      new Promise((resolve)=>{
        this.events.forEach((event, index)=>{
          if(event.resourceId == resourceId){
            this.events[index].color = "#cccccc";
          }
          if(info.event.id == event.id){
            selectedEventIndex = index;
          }
          if(event.resourceId == resourceId && event.start == end && index !== selectedEventIndex){
            mergeAvailable = true;
            mergeTypeBefore = true;
            mergeEventIndexBefore = index;
          }
          if(event.resourceId == resourceId && event.end == start && index !== selectedEventIndex){
            mergeAvailable = true;
            mergeTypeAfter = true;
            mergeEventIndexAfter = index;
          }
          counter++
          if(counter == this.events.length){
            resolve()
          }
        })
      })
      .then(()=>{
        if(mergeAvailable){
          if(mergeTypeBefore && mergeTypeAfter){
            this.events[mergeEventIndexAfter].end = this.events[mergeEventIndexBefore].end;
            this.events[mergeEventIndexAfter].color = "#cccccc";
            this.events.splice(selectedEventIndex,1)
            this.events.splice(mergeEventIndexBefore,1)
          }
          else if(mergeTypeBefore && !mergeTypeAfter){
            this.events[mergeEventIndexBefore].start = start;
            this.events[mergeEventIndexBefore].color = "#cccccc";
            this.events.splice(selectedEventIndex,1)
          }
          else if(!mergeTypeBefore && mergeTypeAfter) {
            this.events[mergeEventIndexAfter].end = end;
            this.events[mergeEventIndexAfter].color = "#cccccc";
            this.events.splice(selectedEventIndex,1)
          }
        }
        else{
          this.events[selectedEventIndex].start = start;
          this.events[selectedEventIndex].end = end;
          this.events[selectedEventIndex].color = "#cccccc"
        }
      })
      .then(()=>{
        this.refreshCalendar();
        this.updatedResourceSchedulde(resourceId);
      })
    },

    loadUserComp() {
      this.loading = true;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        })
        .then(() => {
          this.loadBranches();
          
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

    loadBranches(){
      this.loading = true;
      this.branches = [];
      db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => { 683045430
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.branches.push(branchCollection);
            
            // this.selectedBranchesSalonhub.push(doc.data().branchNameSalonhub);
          })
        })
        .then(()=>{
          this.selectedBranch = this.branches[0].id;
          this.getPositions();
          this.getEmployees();
        })    
    },

    next(){
      let weekNumberOriginal = _.cloneDeep(this.selectedWeeknumber)
      this.calendar.next();

      if(this.calendarView == 'week'){
         this.selectedDate = moment(this.selectedDate ).add(7, 'days').format("YYYY-MM-DD");
      }
      else{
        this.selectedDate = moment(this.selectedDate ).add(1, 'days').format("YYYY-MM-DD");
      }     
      this.selectedYear = moment(this.selectedDate).year()
      this.selectedWeeknumber = moment(moment(this.selectedDate ).add(1, 'days')).isoWeek();
      this.selectedWeekFirstDay = moment(moment(this.selectedDate ).add(1, 'days')).startOf('week').format("D MMMM YYYY");
      this.selectedWeekLastDay = moment(moment(this.selectedDate ).add(1, 'days')).endOf('week').format("D MMMM YYYY");

      if(weekNumberOriginal !== this.selectedWeeknumber){
        this.getSchedules()
      } else{
        this.calculateSummary()
      }
      this.$refs.branchCalendar.getApi().refetchEvents();
    },

    previous(){
      let weekNumberOriginal = _.cloneDeep(this.selectedWeeknumber)
      this.calendar.prev();
      if(this.calendarView == 'week'){
         this.selectedDate = moment(this.selectedDate ).subtract(7, 'days').format("YYYY-MM-DD");
      }
      else{
        this.selectedDate = moment(this.selectedDate ).subtract(1, 'days').format("YYYY-MM-DD");
      }
      this.selectedYear = moment(this.selectedDate).year()
      this.selectedWeeknumber = moment(moment(this.selectedDate ).add(1, 'days')).isoWeek();
      this.selectedWeekFirstDay = moment(moment(this.selectedDate ).add(1, 'days')).startOf('week').format("D MMMM YYYY");
      this.selectedWeekLastDay = moment(moment(this.selectedDate ).add(1, 'days')).endOf('week').format("D MMMM YYYY");

      if(weekNumberOriginal !== this.selectedWeeknumber){
        this.getSchedules()
      }else{
        this.calculateSummary()
      }
      this.$refs.branchCalendar.getApi().refetchEvents();
    },

    resourceRender(resourceObj){
      //custom html resource creation


      let resHeader = document.createElement("div");
        let title = document.createElement("div");
        let position = document.createElement('p');
        let hours = document.createElement("p");
        hours.setAttribute("style", " font-size: 12px; margin: 0; padding: 0;");
        position.setAttribute("style", "margin: 0; padding: 0;");
        title.setAttribute("style", " font-size: 14px; font-weight: bold;");

        if (resourceObj.resource.extendedProps.hours) {
          hours.innerHTML = resourceObj.resource.extendedProps.hours + " uur";
        }
        else {
          hours.innerHTML = "Geen uren";
        }
        if(resourceObj.resource.extendedProps.positionName){
          position.innerHTML = resourceObj.resource.extendedProps.positionName;
        }
        else{
          position.innerHTML = "Functie onbekend"
        }

        title.innerHTML = resourceObj.resource.title;
        resHeader.appendChild(position);
        resHeader.appendChild(hours);

        let arrayOfDomNodes = [title, resHeader];

        return { domNodes: arrayOfDomNodes };
    }, 

    getPositions(){ 
      console.log("Get positions")
      this.positions = []
      db.collection("positions")
        .where("compId", "==", this.activeCompData.id)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let position = doc.data();
            position.id = doc.id;
            this.positions.push(position)
          })
        })
        .catch(error=>{
          console.error("Laden van positions is niet gelukt: ", error)
        })
    },

    getEmployees(){ 
      this.loading = true; 
      this.employees = []
      db.collection("employees")
        .where("companyId", "==", this.activeCompData.id)
        .where("branches", "array-contains", this.selectedBranch)
        .where("deleted.deleted", "==", false)
        .orderBy("order")
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let employee = doc.data();
            employee.id = doc.id;
            employee.positionName = "";
            employee.hours = 0;
            employee.hourRevenueGoal = 0;
            employee.title = doc.data().firstName + " " + doc.data().lastName;
            this.employees.push(employee);
          })
        })
        .then(()=>{
          this.loading = false;
          this.getSchedules();
        })
        .catch(error=>{
          console.error("Laden van employees is niet gelukt: ", error);
        })
    },

    getSchedules(){     
      if(this.employees.length > 0){
        this.calanderChecking = true;
        this.resources = [];
        this.events = [];
        let counter = 0;
        new Promise((resolve) => {
          this.employees.forEach(employee => {
            let schedule = null;
            let scheduleDocId = null;
            let scheduleType = "scheduleBasic";
            db.collection("schedules")
            .where("compId", "==", this.activeCompData.id)
            .where("branchId", "==", this.selectedBranch)
            .where("year", "==", this.selectedYear)
            .where("week", "==", this.selectedWeeknumber)
            .where("employeeId", "==", employee.id)
            .get()
            .then(snap => {
              if(snap.size > 0){
                console.log("Uitzondering op basisschema");
                snap.forEach(doc => {
                  schedule = doc.data().schedule;
                  scheduleDocId = doc.id;

                })
                scheduleType = "scheduleExample"
              } else{
                // console.log("Geen uitzondering op basisschema")
                if(employee.basicSchedule[this.selectedBranch]){
                  if(employee.basicSchedule[this.selectedBranch]){
                    schedule = employee.basicSchedule[this.selectedBranch]
                  }
                }
              }
            })
            .then(()=>{
              if(schedule){
                const days = Object.keys(schedule)
                for (const day of days) {
                  let dayOfWeek = null;
                  if(day == 'sun'){ dayOfWeek = 0};
                  if(day == 'mon'){ dayOfWeek = 1};
                  if(day == 'tue'){ dayOfWeek = 2};
                  if(day == 'wed'){ dayOfWeek = 3};
                  if(day == 'thu'){ dayOfWeek = 4};
                  if(day == 'fri'){ dayOfWeek = 5};
                  if(day == 'sat'){ dayOfWeek = 6};
                  if(dayOfWeek != null){
                    schedule[day].forEach(item=> {
                      let event = {
                        day: dayOfWeek,
                        startEditable: true,
                        id: this.events.length,
                        docId: scheduleDocId,
                        resourceId: employee.id,
                        
                        start: moment(this.selectedDate).day(dayOfWeek).format("YYYY-MM-DD") + "T" + item.start,
                        end: moment(this.selectedDate).day(dayOfWeek).format("YYYY-MM-DD") + "T" + item.end,
                        color: '#eeeeee',
                      }
                      if(scheduleType == "scheduleExample"){
                        event.color = "#cccccc";
                      }
                      this.events.push(event)
                    })
                  }
                }
              }
              this.resources.push(employee);
              counter++
              if(counter == this.employees.length){
                this.calendarOptions.resources = this.resources;
                resolve()
              }
            })
          })
        })
              
        .then(()=>{
          this.calendar = this.$refs.branchCalendar.getApi();
          // this.calendar.setOption('locale', NL);
          this.calculateSummary();
        })
        .then(()=>{
          this.calanderChecking = false;
          this.refreshCalendar();
        })
      }
      else{
        this.calendar = this.$refs.branchCalendar.getApi();
        // this.calendar.setOption('locale', NL);
        this.calanderChecking = false
        this.calculateSummary();
      } 
    },

    calculateSummary(){
      console.log("calculate summery: ", this.events.length)
      // Events van vandaag of week filteren per resource en totaal uren weergeven
      let activeResources = {};
      let startDate;
      let endDate;
      let counter = 0;

      if(this.calendarView == 'day'){
        startDate = moment(this.selectedDate).format("YYYY-MM-DD") + "T00:00";
        endDate = moment(this.selectedDate).format("YYYY-MM-DD") + "T23:59";
      }
      else{
        startDate = moment(this.selectedWeekFirstDay, "D MMMM YYYY").format("YYYY-MM-DD") + "T00:00";
        endDate = moment(this.selectedWeekLastDay, "D MMMM YYYY").format("YYYY-MM-DD") + "T23:59";
      }
      new Promise(resolve=>{
        if(this.events.length > 0){
          this.events.forEach(event=>{
            this.resources.forEach(resource=>{
              if(event.start >= startDate && event.end <= endDate && event.resourceId ==  resource.id){
                if(!activeResources[resource.id]){
                  activeResources[resource.id] = [];
                  activeResources[resource.id].push(event);
                } else{
                  activeResources[resource.id].push(event);
                }
              }
            })
            counter++
            if(counter == this.events.length){
              resolve()
            }
          })
        }
        else{
          console.log("geen events")
          resolve()
        }
      })
      .then(()=>{
        let timeCounter = 0;
        this.totalHours = 0;
        const activeResource = Object.keys(activeResources)
        new Promise(resolve=>{
          if(activeResource.length > 0){
            for (const resource of activeResource) {
              if(activeResources[resource].length > 0){
                activeResources[resource].hours = 0
                activeResources[resource].forEach(event=>{
                  activeResources[resource].hours = activeResources[resource].hours + Number(moment(event.end).diff(moment(event.start), 'minutes') / 60)
                  this.totalHours = this.totalHours + Number(moment(event.end).diff(moment(event.start), 'minutes') / 60)
                })
              }
              timeCounter++
              if(timeCounter == activeResource.length){
                console.log("timeCounter resolved")
                resolve()
              }
            }
          }
          else{
            resolve()
          }
        })
        .then(()=>{
          let employeeCounter = 0
          new Promise(resolve=>{
            this.employees.forEach(employee=>{
              employee.positionName = "";
              employee.hours = 0;
              employee.hourRevenueGoal = 0;
              
              this.positions.forEach(position=>{
                if(position.id == employee.position){
                  employee.positionName = position.name;
                  employee.hourRevenueGoal = position.revenue;
                }
              })
              employeeCounter++
            })
            if(employeeCounter == this.employees.length){
              resolve()
            }
          })
          .then(()=>{
            let employeeCounterTwo= 0;
            this.goalRevenue = 0;
            this.activeResources = 0;

            new Promise(resolve=>{
              this.employees.forEach(employee=>{
                if(activeResources[employee.id]){
                  this.activeResources++
                  employee.hours = activeResources[employee.id].hours;
                  employee.revenueGoal = activeResources[employee.id].hours * employee.hourRevenueGoal;
                  this.goalRevenue = this.goalRevenue + employee.revenueGoal;
                }
                employeeCounterTwo++
              })
              if(employeeCounterTwo == this.employees.length){
                resolve()
              }
            })
            .then(()=>{
              console.log("resolve")
              this.refreshCalendar();
            })

          })
          
        })

      })
    },


    calendarLoading() {
      return this.loading || this.calendarChecking ? true : false;
    },

    updatedResourceSchedulde(resource){
      let counter = 0
      let databaseDocId;
      let schedule = {
        sun: [],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        sat: []
      }

      new Promise(resolve=>{
        this.events.forEach(event=>{
          let dayOfWeek = 'sun'
          if(event.resourceId == resource){
            if(event.docId){
              databaseDocId = event.docId;
            }
            if(event.day == '1'){ dayOfWeek = 'mon'};
            if(event.day == '2'){ dayOfWeek = 'tue'};
            if(event.day == '3'){ dayOfWeek = 'wed'};
            if(event.day == '4'){ dayOfWeek = 'thu'};
            if(event.day == '5'){ dayOfWeek = 'fri'};
            if(event.day == '6'){ dayOfWeek = 'sat'};
            schedule[dayOfWeek].push({
              start: moment(event.start).format("HH:mm"),
              end: moment(event.end).format("HH:mm"),
            })
            schedule[dayOfWeek] = _.orderBy(schedule[dayOfWeek], ['start'],['asc']);
            counter++
            if(counter == this.events.length){
              resolve()
            }
          }
          else{
            counter++
            if(counter == this.events.length){
              resolve()
            }
          }
        })
      })
      .then(()=>{
        if(databaseDocId){
          //console.log("Database document updated")
          db.collection("schedules")
          .doc(databaseDocId)
          .set({
            schedule: schedule,
          }, { merge: true })
          .then(()=>{
             this.calculateSummary();
          })
          .catch(error => {
            console.error("Error updated schedule: ", error);
            this.busy = true
          });
        } 
        else{
          //console.log("Nieuw database document aanmaken")
          db.collection("schedules")
          .doc()
          .set({
            compId: this.activeCompData.id,
            branchId: this.selectedBranch,
            employeeId: resource,
            week: this.selectedWeeknumber,
            year: this.selectedYear,
            schedule: schedule,
          }, { merge: true })
          .then(()=>{
             this.calculateSummary();
          })
          .catch(error => {
            console.error("Error updated schedule: ", error);
            this.busy = true
          });
        }
      })
    },

    refreshCalendar() {
      console.log("refreshCalendar");
      this.$refs.branchCalendar.getApi().refetchEvents();
      this.$refs.branchCalendar.getApi().refetchResources();
      this.calculateCalendarHeight();
    },    
  },

  computed: {

    activeYears(){
      let currentYear = Number(moment().year())
      let startDateCompany = moment().format("YYYY-MM-DD")

      if(this.activeCompData.conversion.start){
        startDateCompany = moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY-MM-DD")
      }

      let numberOfYears = moment().diff(startDateCompany, 'years', false) + 2;
      let activeYears = Array.apply(null, Array(numberOfYears))
      let counter = 0

      activeYears.forEach((year, index)=>{
        activeYears[index] = currentYear - counter
        counter++
      })
      return activeYears
    },

    calenderWidth(){
      let width;
      if(this.calendarView == "week"){
        width = ((this.resources.length * 500) + 50) + "px"
      } else{
        width = ((this.resources.length * 200) + 50) + "px"
      }
      return width;
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    calendarDayView(){
      if(this.calendarView == 'day'){
        return true;
      }
      else{
        return false;
      }
    },

    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },
  }
};
</script>

<style >
.calendar-wrapper td.fc-today,
.calendar-wrapperr .fc-unthemed td.fc-day.fc-widget-content,
.calendar-wrapper .fc-unthemed td.fc-today,
.calendar-wrapper .fc-day-today {
  background: var(--v-menu-base)!important;
}


.extra-conversion-info h3{
  padding: 0 0 10px 0;
}

.conversion-client-info .info-label{
  font-weight: 600;
  width: 120px;
  display: inline-block;
}

.no-conversions{
  width: 280px;
  margin: 0px auto;
  padding: 80px 0;
}

.hipster-image{
  width: 130px;
  height: 130px;
  margin: 0 auto;
}

.no-conversions p{
  font-weight: 600;
  text-align: center;
  font-size: 16px;
}

.hipster-1{
  background: url('../assets/hipsters/hipster-1.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-2{
  background: url('../assets/hipsters/hipster-2.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-3{
  background: url('../assets/hipsters/hipster-3.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-4{
  background: url('../assets/hipsters/hipster-4.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-5{
  background: url('../assets/hipsters/hipster-5.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-6{
  background: url('../assets/hipsters/hipster-6.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-7{
  background: url('../assets/hipsters/hipster-7.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-8{
  background: url('../assets/hipsters/hipster-8.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-9{
  background: url('../assets/hipsters/hipster-9.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-10{
  background: url('../assets/hipsters/hipster-10.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-11{
  background: url('../assets/hipsters/hipster-11.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-12{
  background: url('../assets/hipsters/hipster-12.png') no-repeat center center;
  background-size: 110px auto;
}

.conversion-selected-period p {
  text-align: center;
  padding: 15px 0 5px 0;
  text-transform: lowercase;
}

 .v-toolbar.custom-toolbar .v-toolbar__content, 
 .v-toolbar.custom-toolbar .v-toolbar__extension{
   padding: 0!important;
 }
 .query-filter{
   padding: 10px;
 }
 .calendar-wrapper{
    max-width: 100%;
    min-width: 100%;
    overflow: hidden;
    display: inline-block;
    background: var(--v-menu-base)!important; 
 } 

 .calendar-wrapper .fc-theme-standard .fc-scrollgrid {
    /* border-left: 0; */
    border-right: 0;
  }

.calendar-wrapper .fc-view-container{
  background-color: var(--v-menu-base);
}

.calendar-wrapper .fc-toolbar.fc-header-toolbar{
  display: none;
}

.calendar-wrapper .fc-scroller.fc-time-grid-container::-webkit-scrollbar {
  display: none;
}
 
</style>
